import React, { FC, useState, useEffect, ChangeEvent } from 'react';
import { UseControllerOptions, useController } from 'react-hook-form';

import { IMaskInput } from 'react-imask';
import { Wrapper } from './StaleInputCurrency.styles';

interface OwnProps extends UseControllerOptions {
  id: string;
  type?: HTMLInputElement['type'];
  label?: string;
  view?: 'static' | 'moving';
  icon?: string;
  onActionIcon?: () => any;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => any;
  locked?: boolean;
  currencyPrefix?: string;
  error?: string;
  wrapperStyle?: React.CSSProperties;
}

const StaleInputCurrency: FC<OwnProps> = ({
  id,
  name = '',
  label = '',
  view = 'static',
  type = 'text',
  defaultValue = '',
  icon = '',
  onActionIcon = (e) => e,
  locked = false,
  control,
  rules,
  currencyPrefix = '',
  error = '',
  wrapperStyle = {},
}) => {
  const {
    field: { ref, value, onChange },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const [focused, setFocused] = useState(false);
  const [filled, setFilled] = useState(false);

  useEffect(() => {
    setFilled(!!value);
  }, [value]);

  return (
    <Wrapper
      className={`${view}`}
      icon={!!icon}
      locked={locked}
      error={!!error}
      currencyPrefix={!!currencyPrefix}
      filled={filled}
      focused={focused}
      style={wrapperStyle}
    >
      <div className="wrap">
        {label && (
          <label className="label" htmlFor={id}>
            {label}
          </label>
        )}

        {!!currencyPrefix && <div className="prefix">{currencyPrefix}</div>}

        <IMaskInput
          inputMode="decimal"
          className="input"
          value={value === 0 ? '' : value}
          mask={Number}
          radix="."
          scale={2}
          thousandsSeparator=","
          ref={ref}
          id={id}
          type={type}
          placeholder={view === 'static' ? label : ''}
          autoComplete="new-password"
          unmask="typed"
          onAccept={(value) => {
            onChange(value);
          }}
          disabled={locked}
          onFocus={() => setFocused(true)}
          onBlur={(e) => {
            setFocused(false);
            setFilled(!!e.target.value.length && !!label);
          }}
        />
      </div>

      {icon && onActionIcon && (
        <button type="button" className="icon" onClick={onActionIcon}>
          <svg width="24px" height="24px">
            <use xlinkHref={`#${icon}`} />
          </svg>
        </button>
      )}

      {icon && !onActionIcon && (
        <svg className="icon" width="24px" height="24px">
          <use xlinkHref={`#${icon}`} />
        </svg>
      )}

      {error && <span className="error">{error}</span>}
    </Wrapper>
  );
};

export default StaleInputCurrency;
